// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2_Q3k","footer":"ModalFilter_footer__1RHg4"};